<template>
  <div class="footer-container">
    <div class="container">
      <div class="footer-sub-container">
          <div class="footer-about">
            <p>© 2021 TMBill</p>
            <p>GO GREEN.. GO PAPERLESS..</p>
          </div>
          <div class="footer-social-link">
            <a target="_blank" v-if="digital_order_setting.show_fb == 1" :href="digital_order_setting.fb_url">
              <i class="fa fa-facebook"></i>
            </a>
            <a target="_blank"
                v-if="digital_order_setting.show_insta == 1"
                :href="digital_order_setting.insta_url">
              <i class="fa fa-instagram"></i>
            </a>
            <a target="_blank"
                v-if="digital_order_setting.show_linkedin == 1"
                :href="digital_order_setting.linkedin_url">
              <i class="fa fa-linkedin"></i>
            </a>
            <a target="_blank"
                v-if="digital_order_setting.show_pinterest == 1"
                :href="digital_order_setting.pinterest_url">
              <i class="fa fa-pinterest"></i>
            </a>
            <a target="_blank"
                v-if="digital_order_setting.show_website == 1"
                :href="digital_order_setting.website_url">
              <i class="fa fa-globe"></i>
            </a>
            <a target="_blank" v-if="digital_order_setting.whatsapp == 1" :href="`https://api.whatsapp.com/send?phone=${this.digital_order_setting.digi_whatsapp_no}&text=${this.digital_order_setting.digi_whatsapp_msg}`">
              <i class="fa fa-whatsapp"></i>
            </a>
          </div>
          <div class="footer-quick-link">
            <router-link to="/termsandcondition">Terms & Conditions</router-link> |
            <router-link to="/privacypolicy">Privacy Policy</router-link> |
            <router-link to="/refundcancellation">Refund & Cancellation</router-link> |
            <router-link to="/contact">Contact Us</router-link>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Location from "./Location";

export default {
  name: "Footer",
  data() {
    return {
      deliverytype: localStorage.getItem("deliverytype")
        ? localStorage.getItem("deliverytype")
        : null,
      whatsapplink: "",
      url: "",
    };
  },
  mixins: [Location],
  computed: {
    ...mapGetters(["cartItems"]),
    ...mapGetters(["cartTotalPrice"]),
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["getOrderType"]),
    ...mapGetters(["setOutletName"]),
    ...mapGetters(["digital_order_setting"]),
  },
  methods: {
    addToCart(item) {
      //alert("Hello From order")

      //   alert("Add on and Opt group "+JSON.stringify(item))

      //  alert('order type ' +this.getOrderType + ' local storage '+ localStorage.getItem('deliverytype'))

      if (
        (this.getOrderType == "null" &&
          localStorage.getItem("deliverytype") == "null") ||
        (this.getOrderType == null &&
          localStorage.getItem("deliverytype") == null)
      ) {
        // alert('order type ' +this.getOrderType)
        //  this.openModalOrderType()
        /*this.$bvToast.toast(`Please select Order Type First`, {
                
                variant: 'danger',
                toaster: 'b-toaster-bottom-left',
                solid: true,
                autoHideDelay: 2000,
                })*/
      }

      if (
        this.getOrderType != "null" &&
        localStorage.getItem("deliverytype") != "null" &&
        this.getOrderType != null &&
        localStorage.getItem("deliverytype") != null
      ) {
        let menuitem = JSON.stringify(item);
        //  console.log(JSON.parse(menuitem))

        //let qty = 1

        this.$store.dispatch("addMenuToCart", {
          items: JSON.parse(menuitem),
        });

        //console.log("Cart Items "+ item.item_id)

        this.getQuantity(item.item_id);

        let total = 0;
        if (this.cartItems.length != 0) {
          //  console.log("Cart Items "+ JSON.stringify(this.cartItems))

          this.cartItems.find((cartitem) => {
            if (cartitem.item.items.item_id === item.item_id) {
              total = cartitem.quantity;
            }
          });
        }

        //console.log("Total is "+ total)
        if (total === 1) {
          //alert("Hello")
          /*  this.$bvToast.toast(`${item.title} is added into cart successfully`, {
                     
                      variant: 'success',
                      toaster: 'b-toaster-bottom-left',
                      solid: true,
                    })*/
        }
      } else {
        this.openModalOrderType();
      }
    },

    removeProductFromCart(value, name, item) {
      this.$store.dispatch("removeProductFromCart", {
        item_id: value,
        item: item,
      });

      /* this.$bvToast.toast(`${name} is removed from cart successfully`, {
           
            variant: 'danger',
            toaster: 'b-toaster-bottom-left',
            solid: true,
            autoHideDelay: 2000,
            })*/
    },

    clearCartItems() {
      this.$store.dispatch("clearCartItems");

      /*  this.$bvToast.toast(`Cart cleared successfully`, {
            
            variant: 'danger',
            toaster: 'b-toaster-bottom-left',
            solid: true,
            autoHideDelay: 2000,
            })*/
    },
    deleteFromCart(id, value, item) {
      //  console.log("ID is "+ id)
      //  console.log("value is "+ value)
      //alert(JSON.stringify(item))

      /* item = this.cartItems.find(cartitem => {
          return cartitem.item.items.item_id = id
      })
*/

      // console.log("item is "+JSON.stringify(item.item.items.title))

      let total = 0;
      if (this.cartItems.length != 0) {
        this.cartItems.find((cartitem) => {
          if (
            item.addon_optgrp_price == 0 ||
            item.addon_optgrp_price == undefined
          ) {
            // console.log("addon_optgrp_price is zero")
            if (cartitem.item.items.item_id === id) {
              total = cartitem.quantity;
            }
          } else {
            // console.log("addon_optgrp_price is greater than zero")
            if (cartitem.item.items.add_opt_title === item.add_opt_title) {
              total = cartitem.quantity;
            }
          }
        });
      }

      // alert("Total is "+total)
      /*   console.log("value is "+value)
        console.log("item is "+JSON.stringify(item))
        console.log("addon_optgrp_price "+item.addon_optgrp_price)
*/
      //console.log("value is "+value)
      console.log("Total is " + total);

      if (total > 1) {
        this.$store.dispatch("deleteFromCart", {
          item_id: id,
          quantity: 1,
          item: item,
        });

        //
      } else {
        this.removeProductFromCart(id, value, item);

        //   console.log(JSON.stringify(this.cartItems))
        // console.log(this.cartItems.item.items.item_id)
        //console.log("test message")
      }
    },
  },
  mounted() {
    this.url = this.$route.name;
  },
};
</script>